import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import Active from './screens/Active/router';
import End from './screens/End/router';
import Store from './screens/Store/router';
export default (
  <Route
    path="orders"
    getComponent={(Location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./screens/Index/'));
      });
    }}
  >
    {Active}
    {End}
    {Store}
    <IndexRedirect to="active" />
  </Route>
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Orders/router.js
 **/